import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { updatePrimaryPalette, updateSurfacePalette, definePreset } from '@primeuix/themes';

updatePrimaryPalette({
      50: '{xr-primary}',
      100: '{xr-primary}',
      200: '{xr-primary}',
      300: '{xr-primary}',
      400: '{xr-primary}',
      500: '{xr-primary}',
      600: '{xr-primary}',
      700: '{xr-primary}',
      800: '{xr-primary}',
      900: '{xr-primary}',
      950: '{xr-primary}',
  });
  updateSurfacePalette({
    50: '{xr-primary}',
    100: '{xr-primary}',
    200: '{xr-primary}',
    300: '{xr-primary}',
    400: '{xr-primary}',
  });
  definePreset({
    components: {
      pButton: {
        color: '{xr-primary}',
        background: '{xr-primary}',
        borderColor: '{xr-primary}',
        hover: {
          background: '{xr-primary}',
          borderColor: '{xr-primary}',
        },
        disabled: {
          background: '{xr-primary}',
          borderColor: '{xr-primary}',
        }
      }
    }
  })
bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
